import { Routes, Route } from 'react-router-dom';

import ProtectedRoute from './Protected';

import Auth from '../pages/auth';
import Home from '../pages/app/Home';
import Models from '../pages/app/Models';
import Checkout from '../pages/app/Checkout';
import PaymentSuccess from '../pages/app/PaymentSuccess';

const Router = () => {
    return (
        <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/models" element={<Models />} />
            <Route path="/paymentSuccess" element={<PaymentSuccess />} />
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
        </Routes>
    )
}

export default Router;